<!-- Mobile: Foxera Drawer Full -->
@if (responsiveService.isMobileView()) {
  <foxera-drawer-full
    [(visible)]="visible"
    [title]="exerciseName"
    [showFooter]="showVixeyToggle || isTimeOrRepsSection"
    [useCustomFooter]="isTimeOrRepsSection && !showVixeyToggle"
    [saveDisabled]="!hasChanges() || isSaving()"
    [saveButtonType]="'simple-save'"
    [fullSizeContainer]="true"
    [noPadding]="true"
    [isSaving]="isSaving()"
    [showDeleteButton]="false"
    (onClose)="onClose()"
    (onSave)="onApplyVixeyChange()">
    
    <ng-container *ngTemplateOutlet="mobileContent"></ng-container>

    @if (isTimeOrRepsSection && !showVixeyToggle) {
      <div footer>
        <button
          type="button"
          class="w-full px-6 py-3 text-sm font-semibold text-white bg-primary-600 hover:bg-primary-800 rounded-xl transition-colors cursor-pointer"
          (click)="onClose()">
          Done
        </button>
      </div>
    }
  </foxera-drawer-full>
}

<!-- Desktop: Original Dialog -->
@if (!responsiveService.isMobileView()) {
  <!-- Backdrop -->
  <div 
    class="fixed select-none inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in dialog-backdrop"
    (click)="onBackdropClick($event)">
    
    <!-- Dialog -->
    <div class="w-[95vw] max-w-[1400px] h-[90vh] animate-slide-up">
      @if (exerciseName) {
        <div class="relative w-full h-full flex flex-col bg-white rounded-2xl overflow-hidden shadow-2xl">
          
          <!-- Header -->
          <div class="flex items-center justify-end px-6 py-2">
            <!-- Close Button -->
            <button 
              type="button"
              class="w-9 h-9 cursor-pointer flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-900 transition-all duration-200"
              (click)="onClose()"
              aria-label="Close dialog">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <!-- Content Area: Video + Details -->
          <div class="flex-1 min-h-0 flex gap-6 px-6 pb-6">
            <!-- Left: Video Container -->
            <div class="flex-1 flex items-center justify-center bg-gray-50 rounded-xl">
              <ng-container *ngTemplateOutlet="videoContent"></ng-container>
            </div>

            <!-- Right: Exercise Details Panel -->
            <div class="w-80 flex flex-col gap-5 bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-200 overflow-y-auto">
              <ng-container *ngTemplateOutlet="detailsContent"></ng-container>
            </div>
          </div>

          <!-- Footer with Apply Button (always shown in browse mode) -->
          @if (showVixeyToggle) {
            <div class="flex-shrink-0 px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-end gap-3">
              <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                [disabled]="isSaving()"
                (click)="onClose()">
                Cancel
              </button>
              <button
                type="button"
                class="px-6 py-2 text-sm font-semibold rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                [ngClass]="hasChanges() ? 'text-white bg-primary-600 hover:bg-primary-800' : 'text-gray-400 bg-gray-200 cursor-not-allowed'"
                [disabled]="!hasChanges() || isSaving()"
                (click)="onApplyVixeyChange()">
                @if (isSaving()) {
                  <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Saving...</span>
                } @else {
                  <span>Apply Changes</span>
                }
              </button>
            </div>
          } @else if (isTimeOrRepsSection) {
            <div class="flex-shrink-0 px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-end">
              <button
                type="button"
                class="px-6 py-2 text-sm font-semibold text-white bg-primary-600 hover:bg-primary-800 rounded-lg transition-colors cursor-pointer"
                (click)="onClose()">
                Done
              </button>
            </div>
          }

        </div>
      }
    </div>
  </div>
}

<!-- Mobile Content Template -->
<ng-template #mobileContent>
  <div class="flex flex-col gap-4">
    <!-- Video Section -->
    <div class="w-full aspect-video bg-gray-50 rounded-xl overflow-hidden">
      <ng-container *ngTemplateOutlet="videoContent"></ng-container>
    </div>

    <!-- Details Section -->
    <div class="flex flex-col gap-4">
      <ng-container *ngTemplateOutlet="detailsContent"></ng-container>
    </div>
  </div>
</ng-template>

<!-- Video Content Template -->
<ng-template #videoContent>
  @if (animationPath) {
    <div class="relative w-full h-full rounded-xl overflow-hidden">
      <video 
        class="w-full h-full object-contain"
        [src]="animationPath"
        [attr.controls]="responsiveService.isMobileView() ? null : true"
        autoplay
        loop
        playsinline
        controlsList="nodownload">
        Your browser does not support the video tag.
      </video>
    </div>
  } @else {
    <div class="text-center">
      <div class="w-24 h-24 mx-auto mb-4 rounded-xl bg-gray-200 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
      </div>
      <p class="text-gray-500 text-sm md:text-base">No animation available</p>
    </div>
  }
</ng-template>

<!-- Details Content Template -->
<ng-template #detailsContent>
  <div class=" flex flex-col gap-4 px-5 py-6 bg-white/80 shadow-lg rounded-xl m-4 
  md:px-0 md:m-0 md:shadow-none md:rounded-none">

  <!-- Exercise Title - Desktop Only -->
  <div class="hidden md:block mb-2">
    <h2 class="text-2xl font-bold select-text text-grey-950">{{ exerciseName }}</h2>
  </div>

  <!-- Total Time / Total Reps Editor (Warmup & Cardio) -->
  @if (isTimeOrRepsSection) {
    <div class="space-y-2">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">
        {{ timeOrRepsMode === 'time' ? 'Total Time' : 'Total Reps' }}
      </h3>

      <!-- Value Display -->
      <div class="text-center py-2">
        @if (timeOrRepsMode === 'time') {
          <span class="text-4xl font-bold text-primary-600 select-text">
            {{ formatSecondsAsMinSec(tempTimeSeconds) }}
          </span>
        } @else {
          <div class="inline-flex items-baseline gap-2">
            <span class="text-4xl font-bold text-primary-600 select-text">{{ tempReps }}</span>
            <span class="text-lg font-medium text-gray-600">reps</span>
          </div>
        }
      </div>

      <!-- Slider -->
      @if (timeOrRepsMode === 'time') {
        <p-slider
          [ngModel]="tempTimeSeconds"
          (ngModelChange)="onTimeSliderChange($event)"
          [min]="0"
          [max]="timeMax"
          [step]="timeStep"
          styleClass="w-full">
        </p-slider>
        <div class="flex justify-between mt-2 text-xs text-gray-500">
          <span>{{ formatSecondsAsMinSec(0) }}</span>
          <span>{{ formatSecondsAsMinSec(timeMax) }}</span>
        </div>
      } @else {
        <p-slider
          [ngModel]="tempReps"
          (ngModelChange)="onRepsSliderChange($event)"
          [min]="0"
          [max]="repsMax"
          [step]="repsStep"
          styleClass="w-full">
        </p-slider>
        <div class="flex justify-between mt-2 text-xs text-gray-500">
          <span>0 reps</span>
          <span>{{ repsMax }} reps</span>
        </div>
      }
    </div>
  }

  <!-- Level -->
  <div class="space-y-2">
    <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Level</h3>
    <span 
      class="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-sm font-semibold select-text"
      [ngClass]="getLevelClass(level)">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
      {{ level }}
    </span>

    <!-- Duration (non Warmup/Cardio sections) -->
    @if (!isTimeOrRepsSection && avgDuration && avgDuration > 0) {
      <div class="mt-3">
        <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Expected Duration</h3>
        <div class="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-gray-100 rounded-lg select-text">
          <i class="pi pi-clock text-gray-600"></i>
          <span class="text-sm font-semibold text-gray-600">{{ avgDuration }} minutes</span>
        </div>
      </div>
    }
  </div>

  <!-- Category -->
  @if (category) {
    <div class="space-y-2">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Category</h3>
      <div class="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-gray-100 rounded-lg select-text">
        <i class="pi pi-tag text-gray-600"></i>
        <span class="text-sm font-semibold text-gray-600">{{ category }}</span>
      </div>
    </div>
  }

  <!-- Muscles -->
  @if (muscles && muscles.length > 0) {
    <div class="space-y-3">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Target Muscles</h3>
      <div class="flex flex-wrap gap-2">
        @for (muscle of muscles; track muscle) {
          <span class="inline-flex items-center px-2.5 md:px-3 py-1 md:py-1.5 bg-white border border-gray-200 text-gray-700 rounded-full text-xs md:text-sm font-medium shadow-sm select-text">
            {{ muscle }}
          </span>
        }
      </div>
    </div>
  }

  <!-- Tags -->
  @if (tags && tags.length > 0) {
    <div class="space-y-3">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Tags</h3>
      <div class="flex flex-wrap gap-2">
        @for (tag of tags; track tag) {
          <span class="inline-flex items-center bg-gray-100 text-gray-600 px-2.5 md:px-3 py-1 md:py-1.5 rounded-md text-xs md:text-sm font-semibold select-text">
            ✦ {{ tag }}
          </span>
        }
      </div>
    </div>
  }
  
  <!-- Vixey Availability -->
  @if (showVixeyToggle && availableToVixey !== undefined) {
    <div class="space-y-2">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Vixey Availability</h3>
      <div class="flex items-center justify-between px-3 md:px-4 py-2 md:py-3 bg-gray-50 rounded-lg border border-gray-200">
        <div class="flex items-center gap-2">
          @if (isAvailableToVixey()) {
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <span class="text-sm font-semibold text-green-700">Available</span>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <span class="text-sm font-semibold text-red-700">Not Available</span>
          }
        </div>
        
        <!-- Toggle Switch -->
        <label class="relative inline-block w-12 h-6 cursor-pointer">
          <input 
            type="checkbox" 
            class="sr-only peer"
            [checked]="isAvailableToVixey()"
            (change)="onToggleVixeyAvailability()">
          <div class="w-12 h-6 bg-gray-300 rounded-full peer peer-checked:bg-green-500 transition-colors"></div>
          <div class="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-6"></div>
        </label>
      </div>
    </div>
  } @else if (availableToVixey !== undefined) {
    <!-- Read-only display (non-browse mode) -->
    <div class="space-y-2">
      <h3 class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Vixey Availability</h3>
      @if (availableToVixey) {
        <div class="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-green-50 rounded-lg border border-green-200 select-text">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <span class="text-sm font-semibold text-green-700">Available on Vixey</span>
        </div>
      } @else {
        <div class="flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-red-50 rounded-lg border border-red-200 select-text">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <span class="text-sm font-semibold text-red-700">Not Available on Vixey</span>
        </div>
      }
    </div>
  }
</div>

</ng-template>
